// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.card div.panel {
  background: #fdfdfd;
  border: 1px solid #dfdfdf;
}

div.card-title {
  padding: 0;
  border-bottom: 1px solid #dfdfdf;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 15px;
}

div.card-title span {
  font-size: 15px;
  font-weight: 600;
  opacity: 0.8;
  padding-right: 10px;
  flex: 1 1;
}

div.card-home h3.title {
  font-size: 14px;
  opacity: 0.8;
}

div.card-home h3.title.pending {
  opacity: 0.6;
}

div.card-home p {
  font-size: 18px;
  font-weight: 900;
}

div.card-home p.pending {
  opacity: 0.6;
}

div.card-menus {
  display: flex;
  align-items: center;
}

div.card-menus div.icon-default {
  height: 25px;
  background: #fafafa;
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 10px;
  padding-top: 2px;
  cursor: pointer;
}

div.card-menus div.icon-default a {
  font-size: 12px;
  text-decoration: none;
  color: rgb(0, 0, 0);
  font-weight: 600;
}

div.card-menus div.icon-default a:hover {
  opacity: 1;
}

div.card-menus div.icon-danger {
  height: 25px;
  background: rgb(243, 35, 35);
  border: 1px solid #e02c2c;
  border-radius: 3px;
  padding-left: 10px;
  padding-top: 2px;
  padding-right: 10px;
  margin-right: 10px;
}

div.card-menus div.icon-danger a {
  font-size: 12px;
  text-decoration: none;
  color: rgb(255, 255, 255);
  font-weight: 600;
}

div.card-menus div.icon-danger a:hover {
  opacity: 1;
}

.report-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.report-card h3 span {
  font-size: 14px;
  opacity: 0.6;
}

.report-card-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.report-card-icon i {
  font-size: 40px;
  color: rgb(36, 212, 36);
}

.report-card-icon i.fa-funnel-dollar {
  color: rgb(233, 42, 42);
}

.report-card-icon i.fa-clock {
  color: rgb(165, 165, 165);
}

.report-card p {
  font-size: 20px;
  opacity: 0.7;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/App/components/Card/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["div.card div.panel {\n  background: #fdfdfd;\n  border: 1px solid #dfdfdf;\n}\n\ndiv.card-title {\n  padding: 0;\n  border-bottom: 1px solid #dfdfdf;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding-left: 8px;\n  padding-right: 15px;\n}\n\ndiv.card-title span {\n  font-size: 15px;\n  font-weight: 600;\n  opacity: 0.8;\n  padding-right: 10px;\n  flex: 1;\n}\n\ndiv.card-home h3.title {\n  font-size: 14px;\n  opacity: 0.8;\n}\n\ndiv.card-home h3.title.pending {\n  opacity: 0.6;\n}\n\ndiv.card-home p {\n  font-size: 18px;\n  font-weight: 900;\n}\n\ndiv.card-home p.pending {\n  opacity: 0.6;\n}\n\ndiv.card-menus {\n  display: flex;\n  align-items: center;\n}\n\ndiv.card-menus div.icon-default {\n  height: 25px;\n  background: #fafafa;\n  border: 1px solid #dfdfdf;\n  border-radius: 3px;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-right: 10px;\n  padding-top: 2px;\n  cursor: pointer;\n}\n\ndiv.card-menus div.icon-default a {\n  font-size: 12px;\n  text-decoration: none;\n  color: rgb(0, 0, 0);\n  font-weight: 600;\n}\n\ndiv.card-menus div.icon-default a:hover {\n  opacity: 1;\n}\n\ndiv.card-menus div.icon-danger {\n  height: 25px;\n  background: rgb(243, 35, 35);\n  border: 1px solid #e02c2c;\n  border-radius: 3px;\n  padding-left: 10px;\n  padding-top: 2px;\n  padding-right: 10px;\n  margin-right: 10px;\n}\n\ndiv.card-menus div.icon-danger a {\n  font-size: 12px;\n  text-decoration: none;\n  color: rgb(255, 255, 255);\n  font-weight: 600;\n}\n\ndiv.card-menus div.icon-danger a:hover {\n  opacity: 1;\n}\n\n.report-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.report-card h3 span {\n  font-size: 14px;\n  opacity: 0.6;\n}\n\n.report-card-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.report-card-icon i {\n  font-size: 40px;\n  color: rgb(36, 212, 36);\n}\n\n.report-card-icon i.fa-funnel-dollar {\n  color: rgb(233, 42, 42);\n}\n\n.report-card-icon i.fa-clock {\n  color: rgb(165, 165, 165);\n}\n\n.report-card p {\n  font-size: 20px;\n  opacity: 0.7;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
